import React from 'react';
import styled from 'styled-components';

import { isNotNullish } from 'shared/utils/type-utils';
import { ProductCard } from 'src/dispensary-admin/components/product-card';
import { Products } from './product-carousel.types';
import { Container, Header, Title, ViewAllLink, CardsContainer } from './product-carousel.styles';
import { ProductCarouselLoadingSkeleton } from './product-carousel-card/product-carousel-loading-skeleton';

type ProductCarouselProps = {
  label: string;
  loading: boolean;
  products: Products | undefined;
};

export const TEST_ID_CAROUSEL = 'product-carousel';

export function ProductCarouselV2({ label, products, loading }: ProductCarouselProps): JSX.Element | null {
  if (!products || loading) {
    return <ProductCarouselLoadingSkeleton />;
  }

  if (!products.length) {
    return null;
  }

  return (
    <Container data-testid={TEST_ID_CAROUSEL}>
      <Header>
        <Title>{label}</Title>
        <ViewAllLink>View all</ViewAllLink>
      </Header>

      <CardsContainer $isProductCardsV2Enabled>
        {products.filter(isNotNullish).map((product) => (
          <ProductCardWrapper key={product.id}>
            <ProductCard product={product} />
          </ProductCardWrapper>
        ))}
      </CardsContainer>
    </Container>
  );
}

const ProductCardWrapper = styled.div`
  width: 184px;
`;
